import { useQuery } from '@tanstack/react-query';

import fetchPistonParts from '../api/fetchPistonParts';

/**
 * All piston parts across projects, with owning project names. Not cached:
 * the start-run modal must show pistons added or retired since it was last
 * opened. The modal stays mounted while hidden, so callers gate the query on
 * `enabled` (= modal open); the data is always stale, so each false→true
 * transition refetches and nothing is fetched behind a closed modal.
 */
const usePistonParts = ({ enabled = true } = {}) => useQuery({
  queryKey: ['pistonParts'],
  queryFn: fetchPistonParts,
  enabled,
  staleTime: 0,
});

export default usePistonParts;
